import { isPlatformBrowser } from '@angular/common';
import {
  DOCUMENT,
  inject,
  Injectable,
  PLATFORM_ID,
  Renderer2,
  RendererFactory2,
} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BodyStyleService {
  private renderer: Renderer2;
  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);
  private rendererFactory = inject(RendererFactory2);

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Añade una clase CSS al body del documento.
   * @param className La clase a añadir (ej: 'home-background')
   */
  public addClass(className: string): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.addClass(this.document.body, className);
    }
  }

  /**
   * Elimina una clase CSS del body del documento.
   * @param className La clase a eliminar
   */
  public removeClass(className: string): void {
    if (isPlatformBrowser(this.platformId)) {
      this.renderer.removeClass(this.document.body, className);
    }
  }
}
